import { render, staticRenderFns } from "./MyConversation.vue?vue&type=template&id=e906fe5a"
import script from "./MyConversation.vue?vue&type=script&lang=js"
export * from "./MyConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports